function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import { PMS2HEX } from 'swag-common/utils/colors';
import { RectangleInput } from '../../inputs/rectangle-input';
import { Button } from '../../ui/button';
import classes from './single-pantone-picker.scss';
const defaultLabelText = 'Input exact Pantone color';
const defaultText = 'If this is not correct';
const defaultButtonText = 'apply';
class SinglePantonePicker extends React.Component {
  static isPantoneValid(val) {
    return PMS2HEX(val) !== '';
  }
  constructor(...args) {
    super(args);
    this.state = {
      value: '',
      isInputShown: false,
      errorMessage: null
    };
    this.onChange = this.onChange.bind(this);
    this.showInput = this.showInput.bind(this);
    this.apply = this.apply.bind(this);
    this.handleError = this.handleError.bind(this);
  }
  UNSAFE_componentWillMount() {
    const {
      initialPantone,
      isInputShownInitially
    } = this.props;
    this.setState({
      isInputShown: !!initialPantone || isInputShownInitially
    });
  }
  onChange(e) {
    this.setState({
      errorMessage: null,
      value: e.target.value
    });
  }
  showInput() {
    this.setState({
      isInputShown: true
    });
  }
  apply() {
    const {
      onSubmit,
      shouldValidatePantone
    } = this.props;
    const {
      value
    } = this.state;
    const isValueOfColorPantoneValid = SinglePantonePicker.isPantoneValid(value);
    if (!value.trim()) {
      return;
    }
    if (!isValueOfColorPantoneValid && shouldValidatePantone) {
      return this.handleError();
    }
    const colorData = isValueOfColorPantoneValid && {
      pms: value,
      hex: `#${PMS2HEX(value)}`
    } || {
      pms: value
    };
    onSubmit(colorData);
    this.setState({
      value: '',
      isInputShown: false
    });
  }
  handleError() {
    this.setState({
      errorMessage: "Sorry, we don't recognize such Pantone color"
    });
  }
  render() {
    const {
      value,
      isInputShown,
      errorMessage
    } = this.state;
    const {
      isLimitedEdition,
      className,
      placeholder,
      formType
    } = this.props;
    const labelText = this.props.labelText || defaultLabelText;
    const text = typeof this.props.text === 'string' ? this.props.text : defaultText;
    const buttonText = this.props.buttonText || defaultButtonText;
    if (isInputShown) {
      return /*#__PURE__*/React.createElement("div", {
        className: className
      }, /*#__PURE__*/React.createElement("span", {
        className: classes.inputLabel
      }, labelText), /*#__PURE__*/React.createElement("div", {
        className: classes.row
      }, /*#__PURE__*/React.createElement(RectangleInput, {
        placeholder: placeholder,
        wrapperClassName: classes.inputWrapper,
        input: {
          onChange: this.onChange,
          value
        },
        className: classes.input
      }), /*#__PURE__*/React.createElement(Button, {
        formType: formType,
        className: classnames(classes.button, {
          [classes.orangeBackground]: isLimitedEdition
        }),
        onClick: this.apply,
        type: "primary",
        size: "normal"
      }, buttonText)), errorMessage && /*#__PURE__*/React.createElement("span", {
        className: classes.error
      }, errorMessage), /*#__PURE__*/React.createElement("div", {
        className: classnames(classes.findPantoneColor, {
          [classes.orangeLink]: isLimitedEdition
        })
      }, "Don't know your Pantone color?\xA0", /*#__PURE__*/React.createElement("a", {
        target: "_blank",
        rel: "noreferrer",
        href: "https://swag-prod.s3.us-east-2.amazonaws.com/pantone_color_swatchbook.pdf"
      }, "Find it here.")));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.flex, className)
    }, text, "\xA0", /*#__PURE__*/React.createElement("span", {
      className: classes.wrapperLink
    }, /*#__PURE__*/React.createElement("span", {
      className: classes.link,
      onClick: this.showInput
    }, labelText)));
  }
}
_defineProperty(SinglePantonePicker, "defaultProps", void 0);
SinglePantonePicker.defaultProps = {
  initialPantone: '#000000'
};
export { SinglePantonePicker };